// layouts

import Marketing from "../layouts/Marketing.vue";

// all routes need names for us to properly push page transitions to PostHog
const routes = [
  {
    name: "Marketing",
    path: "/",
    component: Marketing,
    children: [
      {
        name: "Home",
        path: "/",
        component: () => import("../views/Home.vue"),
      },
      {
        name: "Pricing",
        path: "/pricing",
        component: () => import("../views/Pricing.vue"),
      },
      {
        name: "PricingWithPriceId",
        path: "/pricing/:priceId",
        component: () => import("../views/Pricing.vue"),
      },
      {
        name: "PublicResearchCompassDetail",
        path: "/public/:researchCompassId/:viewKey",
        component: () => import("../views/Home.vue"),
      },
      {
        name: "OwnResearchCompassDetail",
        path: "/mine/:researchCompassId",
        component: () => import("../views/Home.vue"),
      },
      {
        name: "PublicResearchCompassPaperDetail",
        path: "/paper/:corpusId",
        component: () => import("../views/Paper.vue"),
      },
      {
        name: "PublicResearchCompassAuthorDetail",
        path: "/author/:authorId",
        component: () => import("../views/Author.vue"),
      },
    ],
  },
  {
    path: "/auth",
    redirect: "/auth/login",
    component: () => import("../layouts/Auth.vue"),
    children: [
      {
        name: "Login",
        path: "/auth/login",
        component: () => import("../views/auth/Login.vue"),
      },
      {
        name: "Logout",
        path: "/auth/logout",
        component: () => import("../views/auth/Logout.vue"),
      },
      {
        name: "ForgotPassword",
        path: "/auth/forgot-password",
        component: () => import("../views/auth/ForgotPassword.vue"),
      },
      {
        name: "ResetPassword",
        path: "/auth/reset-password/:hashedId/:code",
        component: () => import("../views/auth/ResetPassword.vue"),
      },
      {
        name: "SetPassword",
        path: "/auth/set-password/:hashedId/:code",
        component: () => import("../views/auth/SetPassword.vue"),
      },
      {
        name: "Register",
        path: "/auth/register",
        component: () => import("../views/auth/Register.vue"),
      },
      {
        name: "MagicLink",
        path: "/auth/link/:hashedId/:code",
        component: () => import("../views/auth/MagicLink.vue"),
      },
      {
        name: "VerifyEmail",
        path: "/auth/verify-email/:hashedId/:code",
        component: () => import("../views/auth/VerifyEmail.vue"),
      },
    ],
  },
  { name: "GeneralRedirect", path: "/:pathMatch(.*)*", redirect: "/" },
];

export default routes;
